import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('paperwork', 'submit-appointment');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'paperwork',
  type: 'put',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentUUID'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-submit-appointment.js